import React, { memo } from 'react';

import Spinner from '@wetransfer/transfer/component/spinner';
import I18n from '@wetransfer/transfer/modules/i18n';

import styles from './Pending.module.scss';

const Pending = memo(() => {
  return (
    <div className={styles.PendingContainer} data-testid="Pending">
      <Spinner
        className={styles.Spinner}
        rotate={true}
        percentage={25}
        hideText={true}
        circumference={64}
        stroke={4}
      />
      <h3 className={styles.Header}>{I18n.t('transfer.pending.title')}</h3>
      <p className={styles.Subtitle}>{I18n.t('transfer.pending.subtitle')}</p>
    </div>
  );
});

Pending.displayName = 'Pending';

export default Pending;
